/* eslint-disable react/prop-types */
import React from 'react';
import './styles/style.scss';

export const H1 = props => <h1 className="c-vi-header">{props.children}</h1>;

export const H2 = props => <h2 className="c-vi-header">{props.children}</h2>;

export const H3 = props => <h3 className="c-vi-header">{props.children}</h3>;

export const H4 = props => <h4 className="c-vi-header">{props.children}</h4>;

export const H5 = props => <h5 className="c-vi-header">{props.children}</h5>;

export const H6 = props => <h6 className="c-vi-header">{props.children}</h6>;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Headers.jsx